import { useFeatureMembershipsQuery } from 'generated/sanity-graphql';

const useFeatureMemberships = (): {
  liveMemberships: any;
  enableMemberships: boolean;
} => {
  const { data } = useFeatureMembershipsQuery({
    variables: {
      featureMembershipsId: 'feature-memberships-singleton',
    },
  });

  const liveMemberships = data?.LiveMemberships?.liveMemberships!;
  const enableMemberships = liveMemberships?.length! > 0;

  return { liveMemberships, enableMemberships };
};

export default useFeatureMemberships;
